import { IonItem, IonLabel, IonToggle } from '@ionic/react'
import React, { useState } from 'react'
import './Toggle.component.css'

export interface IToggle {
  label: string
  color?: string
  float?: string
}

const ZToggle: React.FC<IToggle> = (props: IToggle) => {
  const [checked, setChecked] = useState(false)
  const { label, color, float } = props
  const floatDirection = float ? float : 'right'

  return (
    <IonItem qa-id='main_ztoggle' lines='none' className={`ion-float-${floatDirection}`}>
      {label && (
        <IonLabel qa-id='item_ztoggle_label' className='toggle-label'>
          {' '}
          {label}:
        </IonLabel>
      )}
      <IonToggle
        qa-id='item_ztoggle_toggle'
        checked={checked}
        color={color}
        onIonChange={(e) => setChecked(e.detail.checked)}
      />
    </IonItem>
  )
}

export default ZToggle
